export default "__VITE_ASSET__CBO$8QwZ__"